export default __webpack_public_path__ + "static/media/2930 cutlery top.3eaf843f.png";